import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { toaster } from 'utils/toast-wrapper'
import { MEMBER_INVOICE_TABLE } from 'constants/tables'

import DeleteButtonComponent from './component'

export const CancelMemberInvoicePayment = combine(
  withTableController({ id: MEMBER_INVOICE_TABLE }),
  withContext(
    'adminMemberInvoiceService',
    ServicesContext,
    ({ adminMemberInvoiceService }) => adminMemberInvoiceService
  ),
  withCallback(
    'onRejectMemberInvoice',
    ({ adminMemberInvoiceService, table }, { value }) =>
      async () => {
        await adminMemberInvoiceService.cancelMemberInvoicePayment(value.number)
        toaster.success('Invoice cancelled successfully.')
        table.refresh()
      },
    ['value']
  )
)(DeleteButtonComponent)
